import React, { useMemo } from "react";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import classNames from "../../../../utils/classNames";
import HotspotMakersList from "./HotspotMakersList";
import HotspotStatistics from "./HotspotStatistics";
import NearbyHotspotsList from "./NearbyHotspotsList";

interface Props {}

const HotspotsTab: React.FC<Props> = () => {
  const { pathname } = useLocation();
  const history = useHistory();

  const activeTab = useMemo(() => {
    if (pathname === "/hotspots/statistics") {
      return "hotspots/statistics";
    } else if (pathname.startsWith("/hotspots/makers")) {
      return "hotspots/makers";
    }
    return "hotspots";
  }, [pathname]);

  return (
    <>
      <div className="sm:px-4 px-3">
        <select
          className="sm:hidden block w-full pl-3 py-2 my-4 sm:text-sm rounded-md dark:bg-gray-800"
          onChange={(e) => {
            history.push(`/${e.target.value}`);
          }}
          value={activeTab}
        >
          {tabs.map(({ key, title }) => (
            <option key={key} value={key}>
              {title}
            </option>
          ))}
        </select>

        <div className="hidden sm:block w-full mt-4 mb-2 rounded-md border border-gray-200 dark:border-gray-500">
          {tabs.map(({ key, title }) => (
            <div
              key={key}
              onClick={() => {
                history.push(`/${key}`);
              }}
              className={classNames(
                activeTab === key
                  ? "bg-hotspotty-400 text-white"
                  : "bg-gray-200 dark:bg-gray-800 text-gray-600 dark:text-gray-300",
                "w-2/6 inline-flex p-2  text-xs font-medium justify-center cursor-pointer border-gray-300 dark:border-gray-500",
                "first:rounded-tl-md first:rounded-bl-md first:border-r last:rounded-tr-md last:rounded-br-md last:border-l"
              )}
            >
              {title}
            </div>
          ))}
        </div>
      </div>

      <Switch>
        <Route path="/hotspots/statistics" component={HotspotStatistics} />
        <Route path="/hotspots/makers" component={HotspotMakersList} />
        <Route path="/hotspots" component={NearbyHotspotsList} />
      </Switch>
    </>
  );
};

export default HotspotsTab;

//
// Utils
//

const tabs = [
  { key: "hotspots", title: "Nearby" },
  { key: "hotspots/makers", title: "Makers" },
  { key: "hotspots/statistics", title: "Statistics" }
];
